// https://github.com/hello-pangea/dnd (React 18 compatible community fork)
import React, { useState, useEffect, useCallback } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { Icon } from "semantic-ui-react";

const ColumnReorder = ({
  items,
  reorderColumns,
  removeColumn,
  getListStyle,
  getItemStyle,
}) => {
  const [localItems, setLocalItems] = useState(items);

  // keep state synced with parent state via props.items
  useEffect(() => {
    setLocalItems(items);
  }, [items]);

  // a little function to help us with reordering the result
  const reorder = useCallback((list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  }, []);

  const onDragEnd = useCallback(
    (result) => {
      // dropped outside the list
      if (!result.destination) {
        return;
      }

      const reorderedItems = reorder(
        localItems,
        result.source.index,
        result.destination.index
      );

      // update parent state
      reorderColumns(reorderedItems);
    },
    [localItems, reorder, reorderColumns]
  );

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable" direction="horizontal">
        {(provided, snapshot) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={getListStyle(snapshot.isDraggingOver, localItems.length)}
          >
            {localItems.map((item, index) => (
              <Draggable key={item.id} draggableId={item.id} index={index}>
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{
                      ...getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                      ),
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div dangerouslySetInnerHTML={{ __html: item.content }} />
                    <Icon
                      name="cancel"
                      color="red"
                      style={{ cursor: "pointer" }}
                      title="Remove from column set"
                      onClick={() => removeColumn(item.id)}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default ColumnReorder;
